import { Component, OnInit, ViewChild } from '@angular/core';
import { AuthenticationService, UserService, SEOService, AppSettings, HelperService } from '../../services/_services';
import { Location } from '@angular/common';
import { environment } from '../../../environments/environment';

import { Router, Route, ActivatedRoute, NavigationEnd } from "@angular/router";
import Swal from 'sweetalert2';

@Component({
  selector: 'app-new-header',
  templateUrl: './new-header.component.html',
  styleUrls: ['./new-header.component.css']
})
export class NewHeaderComponent implements OnInit {

  @ViewChild('sideMenu',{static:false}) sideMenu: any
  @ViewChild('mainMenu',{static:false}) mainMenu: any

  public menus :any = [
    { name: "Articles",                   route: "/services",              active: false,  onlyAdmin: false, content_writer : false  },
    { name: "Blogs",                      route: "/blogs",                 active: true, onlyAdmin: false, content_writer : true },
    { name: "Service Page",               route: "/service-page",          active: false, onlyAdmin: false, content_writer : false },
    { name: "Samples",                    route: "/samples",            active: false, onlyAdmin: false, content_writer : true  },
    { name: "Writers",                    route: "/writers",               active: false, onlyAdmin: false, content_writer : true  },
    { name: "Authors",                    route: "/authors",               active: false, onlyAdmin: false, content_writer : true  },
    { name: "Users",                      route: "/users",                 active: false, onlyAdmin: true, content_writer  : false  },
    { name: "Logs",                       route: "/logs",                  active: false, onlyAdmin: false, content_writer  : true  },
    { name: "Account",                    route: "/account",               active: false, onlyAdmin: false, content_writer : true  },
  ];
  currentRoute : any;

  public activeUser            : any;
  public activeRoute           : any;
  public routerSubscription    : any;

  constructor(
    private userService: UserService,
    private authenticationService: AuthenticationService,
    private activatedRoute: ActivatedRoute,
    private router: Router,
    private seoService: SEOService,
    private helperService: HelperService,
    private _location: Location,
  ) {
    this.routerSubscription = this.router.events.subscribe((val) => {
      // Get Current User
      this.activeUser = this.authenticationService.get_currentUserValue();

      if(val instanceof NavigationEnd) {
        this.activeRoute = val.url;

        if(val.url == '/') {
            this.menus[0].active = true;
        } else {
            for (let i = 0; i < this.menus.length; i++) {
                if(this.menus[i].route == val.url)
                  this.menus[i].active = true;
                else
                  this.menus[i].active = false;
            }
        }

        // Only admin can manage users
        if((this.activeRoute === '/users' || this.activeRoute === '/bin') && this.activeUser.role !== 'Admin')
          this.router.navigate(['/']);
        }

    });
  }

  ngOnInit(){
    setInterval(() => {
      this.checkSecurityCode()
    }, 5000);
  }

  showSideMenu(){
    this.sideMenu.nativeElement.classList.add('show');
    setTimeout(() => {
      this.mainMenu.nativeElement.classList.add('show');
    }, 10)
  }
  hideSideMenu(){
    this.mainMenu.nativeElement.classList.remove('show');
    this.sideMenu.nativeElement.classList.remove('show');
  }

  logout() {
    this.authenticationService.simpleLogout();
    this.router.navigate(['/login']);
  }

  checkSecurityCode(){
    // Skip security check in development mode
    if (!environment.production) {
      return;
    }
    
    let security_entered = localStorage.getItem('securityEntered')
    let swal_shown = $(".swal2-container")
    if(!security_entered && !swal_shown.length && this.activeUser){
      Swal.fire({
          title: 'Please enter security code to continue',
          type: 'warning',
          input: 'password',
          inputPlaceholder: 'Enter your password',
          inputAttributes: {
              autocapitalize: 'off',
              autocorrect: 'off'
          },
          confirmButtonText: 'Yes',
          allowOutsideClick: false, // Prevent closing by clicking outside
          allowEscapeKey: false, // Prevent closing with Escape key
          allowEnterKey: true, // Allow Enter key to submit
          preConfirm: (password) => {
              if (!password) {
                  Swal.showValidationMessage('Password is required');
                  return false; // Prevent dialog from closing
              }
              if (password != atob(this.activeUser.tokan)) {
                  Swal.showValidationMessage('Incorrect password');
                  return false; // Prevent dialog from closing
              }
              return password; // Return password for further processing
          }
      }).then((result) => {
        if (result.value == atob(this.activeUser.tokan)) {
            security_entered = 'true'
            localStorage.setItem('securityEntered', 'true')
            Swal.fire({
                title: 'Access Granted!',
                type: 'success'
            })
        }
      });
    }
  }


}
